export default "__VITE_ASSET__CeyhIxdj__"